const state = {
    paymentMethod: {},
    paymentMethods: [],
}
const actions = {
    showPaymentMethods: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/payments/method`).then(response => {
                context.commit('SHOW_PAYMENT_METHODS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showPaymentMethod: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/payments/method/${id}`).then(response => {
                context.commit('SHOW_PAYMENT_METHOD', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storePaymentMethod: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/payments/method`, payload).then(response => {
                context.commit('STORE_PAYMENT_METHOD', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updatePaymentMethod: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/payments/method/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyPaymentMethod: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/payments/method/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_PAYMENT_METHOD: (state, payload) => {
        state.paymentMethod = payload
    },
    SHOW_PAYMENT_METHODS: (state, payload) => {
        state.paymentMethods = payload
    },
    STORE_PAYMENT_METHOD: (state, payload) => {
        state.paymentMethod = payload
    }
}
const getters = {
    paymentMethod: state => {
        return state.paymentMethod
    },
    paymentMethods: state => {
        return state.paymentMethods
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
